import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateCouponsGet = {
    path: "/affiliate/coupons",
    method: ERouteHttpVerb.GET
};
export { routeLocationAffiliateCouponsGet };
